import { createFileRoute, Outlet } from '@tanstack/react-router';

export type AccountingListRouteParams = {
  type: 'invoices' | 'bills';
};

export type AccountingDetailRouteParams = AccountingListRouteParams & {
  guid: string;
};

export const Route = createFileRoute('/accounting')({ component: Outlet });
